import React from "react";

const Footer = () => {
  return (
    <div className="montserrat-heading mx-auto text-center text-[1rem] font-semibold text-[#8098a7] sm:pt-0 ">
      © 2023 TeamCloak. All rights reserved.
    </div>
  );
};

export default Footer;
